var chunkToChildrenMap = {
	"9332": [
		9590,
		1706,
		7427,
		8441,
		879,
		7947,
		871,
		4294,
		7697,
		2259,
		7771,
		5067
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));